import {
	section, h1, h2, h3, hr, header, i, ul, li, a, span, img,
	table, thead, tbody, tr, td, th, form, input, button, label
} from 'iblokz-snabbdom-helpers';

import formUtil from '../../util/form';
import dropdown from '../comp/dropdown';

const LANGS = ['en', 'bg'];
const LANG_LABELS = {
	en: 'English',
	bg: 'Български'
};
const flagSrc = lang => ({
	en: '/assets/flags/gb.svg',
	bg: '/assets/flags/bg.svg'
}[lang] || '/assets/flags/gb.svg');

const langOption = code => span('.lang-option', [
	span('.flag-circle', img({
		props: {
			src: flagSrc(code),
			alt: ''
		}
	})),
	span('.lang-label', LANG_LABELS[code])
]);

export default ({ state, actions, i18n }) => {
	const lang = state.lang || 'bg';
	const menuKey = state.router.path[0] === 'admin' ? 'admin' : 'front';
	const menu = (i18n.menu && i18n.menu[menuKey]) || [];

	return header([
		button('.left.menu-toggle', {
			on: {click: () => actions.toggleMenu('main')},
			class: {toggled: state.menu === 'main'}
		}, [
			img(`[src="/assets/icons/${state.menu === 'main' ? 'cancel' : 'menu'}.svg"]`)
		]),
		img('.logo[src="/assets/mbg.svg"]'),
		(!state.auth.user)
			? a('.right.login-menu-toggle', {
				on: {click: () => actions.toggleMenu('log-in')},
				class: {toggled: state.menu === 'log-in'}
			}, [
				img(`[src="/assets/icons/${state.menu === 'log-in' ? 'cancel' : 'write'}.svg"]`)
			])
			: button(`.right.log-out`, {
				on: {click: () => actions.auth.logout()}
			}, [
				img(`[src="/assets/icons/log-out.svg"]`)
			]),
		// float:right stacks leftward — after login so it sits to its left
		dropdown('.flags.right', {
			flags: true,
			toLeft: true,
			handle: [img({
				props: {
					src: flagSrc(lang),
					alt: '',
					title: LANG_LABELS[lang]
				}
			})],
			handleClick: () => {
				const i = LANGS.indexOf(lang);
				const next = LANGS[(i < 0 ? 0 : i + 1) % LANGS.length];
				actions.set('lang', next);
			},
			items: LANGS.map(code => ({
				content: langOption(code),
				active: code === lang,
				onSelect: () => {
					if (code !== lang) actions.set('lang', code);
				}
			}))
		}),
		ul('.main-menu', [].concat(
			(state.auth.user) && li(
				(state.router.admin)
					? a(`[href="/"][title="${(i18n.common && i18n.common.titles && i18n.common.titles.home) || ''}"]`, {
						on: {click: ev => {
							ev.preventDefault();
							actions.set('menu', null);
							actions.router.go('home');
						}}
					}, [
						img(`[src="/assets/icons/newspaper.svg"]`)
					])
					: a(`[href="/admin"][title="${(i18n.common && i18n.common.titles && i18n.common.titles.admin) || ''}"]`, {
						on: {click: ev => {
							ev.preventDefault();
							actions.set('menu', null);
							actions.router.go('admin');
						}}
					}, [
						img(`[src="/assets/icons/dashboard.svg"]`)
					])
			) || '',
			menu.map(item =>
				li(a(`[href="${item.href}"]`, {
					class: {active: item.page === state.router.page},
					on: {
						click: ev => {
							ev.preventDefault();
							actions.set('menu', null);
							const page = item.page === 'admin.home'
								? 'admin'
								: item.page;
							actions.router.go(page);
						}
					}
				}, item.title))
			)
		)),
		ul(`.right${state.auth.user ? '.user-session' : ''}`, [
			li(
				(!state.auth.user)
					? [(state.menu === 'log-in')
						? form({
							on: {
								submit: ev => {
									ev.preventDefault();
									let data = formUtil.toData(ev.target);
									actions.auth.login(data);
								}
							}
						}, [
							label('[for="login-email"]', [img(`[src="/assets/icons/user.svg"]`)]),
							input(`#login-email[name="email"][placeholder="${i18n.common.login.email}"]`),
							label('[for="login-pass"]', [img(`[src="/assets/icons/key.svg"]`)]),
							input(`#login-password[name="password"][type="password"][placeholder="${i18n.common.login.password}"]`),
							button([
								img(`[src="/assets/icons/log-in.svg"]`)
							])
						])
						: ''
					]
					: [
						span('.user-identity', state.auth.user.name || state.auth.user.email)
					])
		])
	]);
};
